module.exports = __webpack_public_path__ + "static/img/servicesbg1.5971ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/servicesbg1.jpg
// module id = 2hWQ
// module chunks = 1